import React from 'react';
import { ImageProps } from '.';

const SvgPartnerPlusText = ({ size = 50, ...props }: ImageProps): JSX.Element => {
  return (
    <svg width={size} height={(size && Math.floor(size / 6.25)) || 8} fill='none' viewBox='0 0 50 8' {...props}>
      <path
        fill='url(#PartnerPlusText_svg__a)'
        d='M8.31 4.471h-.872L6.858 8H5.385L6.695.028h1.473L7.69 2.94h.871L8.31 4.471ZM4.513 6.096c.373-.075.666-.162.88-.262l-.232 1.41c-.24.118-.552.211-.935.28a6.236 6.236 0 0 1-1.115.103H0l.235-1.429h.61l.749-4.555h-.558L1.27.215h4.767l-.235 1.428h-.558l-.732 4.453Zm-2.222.102h.759l.748-4.555H3.04l-.749 4.555Z'
      />
      <path
        fill='url(#PartnerPlusText_svg__b)'
        fillOpacity={0.8}
        d='M8.31 4.471h-.872L6.858 8H5.385L6.695.028h1.473L7.69 2.94h.871L8.31 4.471ZM4.513 6.096c.373-.075.666-.162.88-.262l-.232 1.41c-.24.118-.552.211-.935.28a6.236 6.236 0 0 1-1.115.103H0l.235-1.429h.61l.749-4.555h-.558L1.27.215h4.767l-.235 1.428h-.558l-.732 4.453Zm-2.222.102h.759l.748-4.555H3.04l-.749 4.555Z'
      />
      <path
        fill='url(#PartnerPlusText_svg__c)'
        d='M15.864 5.536H9.075L9.95.215h6.701l-.227 1.381h-5.246l-.103.626H16.2l-.215 1.307H10.86l-.102.625h5.333l-.227 1.382Zm.201.737-.238 1.447h-7.53l.239-1.447h7.53Z'
      />
      <path
        fill='url(#PartnerPlusText_svg__d)'
        fillOpacity={0.8}
        d='M15.864 5.536H9.075L9.95.215h6.701l-.227 1.381h-5.246l-.103.626H16.2l-.215 1.307H10.86l-.102.625h5.333l-.227 1.382Zm.201.737-.238 1.447h-7.53l.239-1.447h7.53Z'
      />
      <path
        fill='url(#PartnerPlusText_svg__e)'
        d='M25.178.028 23.868 8h-1.473l.648-3.94h-2.301l.25-1.52h2.3l.413-2.512h1.473ZM20.115 6.18a6.25 6.25 0 0 0 1.07-.094c.365-.068.67-.158.916-.27l-.235 1.428a3.56 3.56 0 0 1-.926.28c-.372.068-.74.103-1.107.103h-2.84L18.217.168h1.517l-.988 6.012h1.368Z'
      />
      <path
        fill='url(#PartnerPlusText_svg__f)'
        fillOpacity={0.8}
        d='M25.178.028 23.868 8h-1.473l.648-3.94h-2.301l.25-1.52h2.3l.413-2.512h1.473ZM20.115 6.18a6.25 6.25 0 0 0 1.07-.094c.365-.068.67-.158.916-.27l-.235 1.428a3.56 3.56 0 0 1-.926.28c-.372.068-.74.103-1.107.103h-2.84L18.217.168h1.517l-.988 6.012h1.368Z'
      />
      <path
        fill='url(#PartnerPlusText_svg__g)'
        d='M32.992 2.96H26.23l.18-1.093h1.14l.123-.747H26.61l.18-1.092h6.606l-.18 1.092h-1.063l-.123.747h1.142l-.18 1.092Zm-3.986-1.093h1.569l.123-.747h-1.57l-.122.747Zm4.32 1.4-.188 1.14h-7.53l.188-1.14h7.53ZM27.06 7.03h5.29L32.19 8h-6.728l.338-2.054h5.211l.045-.27h-5.23l.159-.962h6.667l-.336 2.044h-5.212l-.044.271Z'
      />
      <path
        fill='url(#PartnerPlusText_svg__h)'
        fillOpacity={0.8}
        d='M32.992 2.96H26.23l.18-1.093h1.14l.123-.747H26.61l.18-1.092h6.606l-.18 1.092h-1.063l-.123.747h1.142l-.18 1.092Zm-3.986-1.093h1.569l.123-.747h-1.57l-.122.747Zm4.32 1.4-.188 1.14h-7.53l.188-1.14h7.53ZM27.06 7.03h5.29L32.19 8h-6.728l.338-2.054h5.211l.045-.27h-5.23l.159-.962h6.667l-.336 2.044h-5.212l-.044.271Z'
      />
      <path
        fill='url(#PartnerPlusText_svg__i)'
        d='M41.944.028 40.634 8H39.16l.586-3.566h-1.08l.251-1.53h1.08l.473-2.876h1.473Zm-5.068 6.18c.349 0 .706-.035 1.072-.103.365-.068.67-.156.914-.261l-.23 1.4c-.24.118-.555.211-.944.28a6.524 6.524 0 0 1-1.15.103h-2.78l.727-4.425h2.563l.257-1.568h-2.58l.234-1.42h4.044l-.721 4.388h-2.563l-.263 1.606h1.42Z'
      />
      <path
        fill='url(#PartnerPlusText_svg__j)'
        fillOpacity={0.8}
        d='M41.944.028 40.634 8H39.16l.586-3.566h-1.08l.251-1.53h1.08l.473-2.876h1.473Zm-5.068 6.18c.349 0 .706-.035 1.072-.103.365-.068.67-.156.914-.261l-.23 1.4c-.24.118-.555.211-.944.28a6.524 6.524 0 0 1-1.15.103h-2.78l.727-4.425h2.563l.257-1.568h-2.58l.234-1.42h4.044l-.721 4.388h-2.563l-.263 1.606h1.42Z'
      />
      <path
        fill='url(#PartnerPlusText_svg__k)'
        d='M46.308 3.062a6.473 6.473 0 0 1-1.842 1.503c-.675.36-1.362.544-2.06.55l.245-1.493c.494 0 .987-.153 1.478-.457.499-.312.947-.741 1.345-1.289.4-.554.7-1.179.901-1.876l1.458.252a7.358 7.358 0 0 1-.67 1.578L50 3.874l-.986 1.279-2.706-2.091Zm-4.236 3.183h7.53l-.243 1.475h-7.53l.243-1.475Z'
      />
      <path
        fill='url(#PartnerPlusText_svg__l)'
        fillOpacity={0.8}
        d='M46.308 3.062a6.473 6.473 0 0 1-1.842 1.503c-.675.36-1.362.544-2.06.55l.245-1.493c.494 0 .987-.153 1.478-.457.499-.312.947-.741 1.345-1.289.4-.554.7-1.179.901-1.876l1.458.252a7.358 7.358 0 0 1-.67 1.578L50 3.874l-.986 1.279-2.706-2.091Zm-4.236 3.183h7.53l-.243 1.475h-7.53l.243-1.475Z'
      />
      <defs>
        <linearGradient
          id='PartnerPlusText_svg__a'
          x1={43.75}
          x2={14.496}
          y1={0}
          y2={18.145}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#6E5BE6' />
          <stop offset={1} stopColor='#B05BF4' />
        </linearGradient>
        <linearGradient
          id='PartnerPlusText_svg__b'
          x1={19.531}
          x2={18.215}
          y1={0}
          y2={9.71}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#7745FF' />
          <stop offset={1} stopColor='#B05BF4' />
        </linearGradient>
        <linearGradient
          id='PartnerPlusText_svg__c'
          x1={43.75}
          x2={14.496}
          y1={0}
          y2={18.145}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#6E5BE6' />
          <stop offset={1} stopColor='#B05BF4' />
        </linearGradient>
        <linearGradient
          id='PartnerPlusText_svg__d'
          x1={19.531}
          x2={18.215}
          y1={0}
          y2={9.71}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#7745FF' />
          <stop offset={1} stopColor='#B05BF4' />
        </linearGradient>
        <linearGradient
          id='PartnerPlusText_svg__e'
          x1={43.75}
          x2={14.496}
          y1={0}
          y2={18.145}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#6E5BE6' />
          <stop offset={1} stopColor='#B05BF4' />
        </linearGradient>
        <linearGradient
          id='PartnerPlusText_svg__f'
          x1={19.531}
          x2={18.215}
          y1={0}
          y2={9.71}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#7745FF' />
          <stop offset={1} stopColor='#B05BF4' />
        </linearGradient>
        <linearGradient
          id='PartnerPlusText_svg__g'
          x1={43.75}
          x2={14.496}
          y1={0}
          y2={18.145}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#6E5BE6' />
          <stop offset={1} stopColor='#B05BF4' />
        </linearGradient>
        <linearGradient
          id='PartnerPlusText_svg__h'
          x1={19.531}
          x2={18.215}
          y1={0}
          y2={9.71}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#7745FF' />
          <stop offset={1} stopColor='#B05BF4' />
        </linearGradient>
        <linearGradient
          id='PartnerPlusText_svg__i'
          x1={43.75}
          x2={14.496}
          y1={0}
          y2={18.145}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#6E5BE6' />
          <stop offset={1} stopColor='#B05BF4' />
        </linearGradient>
        <linearGradient
          id='PartnerPlusText_svg__j'
          x1={19.531}
          x2={18.215}
          y1={0}
          y2={9.71}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#7745FF' />
          <stop offset={1} stopColor='#B05BF4' />
        </linearGradient>
        <linearGradient
          id='PartnerPlusText_svg__k'
          x1={43.75}
          x2={14.496}
          y1={0}
          y2={18.145}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#6E5BE6' />
          <stop offset={1} stopColor='#B05BF4' />
        </linearGradient>
        <linearGradient
          id='PartnerPlusText_svg__l'
          x1={19.531}
          x2={18.215}
          y1={0}
          y2={9.71}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#7745FF' />
          <stop offset={1} stopColor='#B05BF4' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default SvgPartnerPlusText;
